<!--  -->
<template>
    <div class=''>
      <div class="wrapper" v-loads="loading">
        <svg-icon icon-class="smile" class="fontsize"></svg-icon>
        <div class="na" v-for="item in testArr" :key="item.Id">
          {{item.Name}}
        </div>
        <img class="imgSize" :src="imgPathPC+'ycyf_logo.png'" alt="">
        <i class="iconfont icon-Loading"></i>
        <button class="btn" @click="test">请求</button>
        <h2 class="h2Font">Ecosystem</h2>
    <ul>
      <li>
        <a
          href="http://router.vuejs.org/"
          target="_blank"
        >
          vue-router
        </a>
      </li>
      <li>
        <a
          href="http://vuex.vuejs.org/"
          target="_blank"
        >
          vuex
        </a>
      </li>
      <li>
        <a
          href="http://vue-loader.vuejs.org/"
          target="_blank"
        >
          vue-loader
        </a>
      </li>
      <li>
        <a
          href="https://github.com/vuejs/awesome-vue"
          target="_blank"
        >
          awesome-vue
        </a>
      </li>
    </ul>
      </div>
    </div>
</template>

<script>

export default {
    data() {
     return {
       loading:false,
       imgPathPC:this.$store.state.imgPathPC,
       testArr:[]
     };
    },
    mounted() { 
    },
    methods: {
      test(){
        this.$get('SpecialCourse/Get',{}).then(res=>{
            this.testArr=res.Data
        })
      }
    },
    components:{
    
    },
    created() {
    
    },
    computed: {},
    watch: {},
}
</script>
<style scoped lang='scss'>
  .wrapper{
    width: 50%;
    height: 50vh;
    margin: 0 auto;
    .btn{
      font-size:22px;
    }
  }
  ul {
  list-style-type: none;
  padding: 0;
  li {
    font-size: 14px;
    display: inline-block;
    margin: 0 10px;
  }
}
.imgSize{
  width: 200px;
  height:200px;
}
  .na{
    color: $red;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue